<template>
    <div>
        <nav class="w-screen navbar-pc4-desktop absolute" :style="`background-color:${navColor}`">
            <Link :href="route('Home')">
                <div class="w-full relative flex justify-between lg:w-auto">
                    <svg height="30" viewBox="0 0 90 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M55.8336 13.0978L65.788 11.9751C65.3388 8.30645 63.9169 5.46367 61.3736 3.29317C58.8273 1.04781 55.3847 0 50.9689 0C46.7036 0 43.1101 0.972949 40.0415 2.91885C37.9158 4.29603 36.105 6.10666 34.7276 8.23219C34.6164 6.99134 34.2331 5.79026 33.6049 4.71442C32.8049 3.34008 31.6035 2.24347 30.162 1.57187C28.6653 0.898084 26.4199 0.524056 23.4262 0.524056H7.5584L0 35.3265H10.8525L13.5467 22.4533H18.3369L18.7112 15.5678H15.0425L16.8387 7.33559H21.0311C23.3514 7.33559 24.474 8.38341 24.474 10.479C24.474 11.8263 23.8754 13.0239 22.8276 14.0717C21.7798 15.0446 20.4116 15.4022 18.7115 15.5687L18.3369 22.4533C21.8323 22.4094 25.2224 22.0041 27.318 21.106C28.6512 20.5662 29.8702 19.7789 30.9107 18.7858C30.8358 19.609 30.7615 20.5071 30.7615 21.2557C30.7615 25.6701 32.1088 29.2639 34.7285 31.9585C37.4227 34.6527 41.24 36 46.2544 36C51.0443 36 54.9364 34.8025 58.0062 32.3313C60.913 29.9797 63.0286 26.7932 64.0679 23.2016L54.0386 21.6298C53.2154 23.8003 52.1676 25.4476 51.0449 26.4196C49.9058 27.4693 48.4021 28.0332 46.8537 27.9915C45.0575 27.9915 43.7102 27.3929 42.8121 26.2702C41.8392 25.0727 41.39 23.6505 41.39 21.9292C41.4062 19.5144 41.8891 17.1255 42.8121 14.894C43.7102 12.4989 44.9078 10.7027 46.4048 9.58006C47.7042 8.48378 49.3452 7.87505 51.0452 7.85875C52.2726 7.85663 53.4627 8.27981 54.4132 9.0563C55.4611 9.87952 55.9103 11.1519 55.9103 12.8741V13.0987L55.8336 13.0978Z" fill="white"/><path opacity="0.8" fill-rule="evenodd" clip-rule="evenodd" d="M89.8129 0.224609H81.4316L59.2017 21.1809L59.1268 21.7049L65.264 22.6779L67.4345 21.7049L79.1108 10.7027L79.2599 10.7776L76.8648 21.7049H67.4345L65.264 22.6779C64.7519 24.326 64.0485 25.9084 63.1684 27.3929L62.1205 29.1894H75.2184L73.7962 35.7009H82.1039L83.5251 29.1894H87.9395L89.5859 21.7049H85.0227L89.8129 0.224609Z" fill="white"/></svg>
                </div>
            </Link>

            <div class="nav-about-items ml-32">
                <slot name="routes">
                    <Link :href="route('Home')" :class="{'pc-green-nav' : $page.component === 'Home' }">
                        Home
                    </Link>
                    <Link :href="route('WhoWeAre')" :class="{'pc-green-nav' : $page.component === 'WhoWeAre/Index' }">
                        Quem Somos
                    </Link>
                    <PortfolioDropdown />
                </slot>
            </div>
            <div class="nav-contact-items">
                <ContactButton />
                <a href="tel:+853013-5114" title="telefone pc4" target="_blank">
                    <svg class="w-5 h-5 fill-current" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.0375 0C15.5056 0 20 4.49438 20 10.0375C20 15.5056 15.5056 20 10.0375 20C4.49438 20 0 15.5056 0 10.0375C0 4.49438 4.49438 0 10.0375 0ZM7.41573 8.38951C8.53933 10.0375 9.96255 11.4607 11.6105 12.6592L12.6592 11.6105C12.9588 11.236 13.5581 11.236 13.8577 11.6105L15.4307 13.1835C15.8052 13.4831 15.8052 14.0824 15.4307 14.382L14.382 15.4307C12.4345 17.3783 2.62172 7.56554 4.56929 5.61798L5.61798 4.56929C5.99251 4.26966 6.51685 4.26966 6.89139 4.56929L8.46442 6.14232C8.76404 6.51685 8.76404 7.0412 8.46442 7.41573L7.41573 8.38951Z" fill="white"/></svg>
                </a>
                <a href="mailto:contato@pc4.com.br" title="email pc4" target="_blank">
                    <svg class="w-5 h-5 fill-current" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.9348 9.96742C19.9348 15.4723 15.4723 19.9348 9.96742 19.9348C4.46257 19.9348 0 15.4723 0 9.96742C0 4.46257 4.46257 0 9.96742 0C15.4723 0 19.9348 4.46257 19.9348 9.96742ZM10.4094 9.52662L15.0949 4.91923C14.8504 4.80208 14.5829 4.74061 14.3117 4.73926H5.62324C5.35207 4.74061 5.08458 4.80208 4.84003 4.91923L9.52747 9.52848C9.64636 9.64191 9.80447 9.70504 9.96879 9.70469C10.1331 9.70434 10.2909 9.64055 10.4094 9.52662ZM9.96837 10.9415C10.4566 10.9415 10.9259 10.7523 11.2775 10.4136L15.9786 5.79069C16.1051 6.04227 16.1718 6.31964 16.1735 6.6012V12.8073C16.172 13.3006 15.9754 13.7733 15.6266 14.1221C15.2777 14.471 14.805 14.6676 14.3117 14.6691H5.6232C5.12987 14.6676 4.65716 14.471 4.30832 14.1221C3.95948 13.7733 3.76285 13.3006 3.76138 12.8073V6.6012C3.7631 6.31964 3.82979 6.04227 3.95625 5.79069L8.6592 10.4136C9.01088 10.7523 9.48013 10.9415 9.96837 10.9415Z" fill="white"/></svg>
                </a>
            </div>
        </nav>
        <nav class="flex justify-between items-center lg:hidden py-5 px-5 absolute">
            <svg height="20" viewBox="0 0 90 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M55.8336 13.0978L65.788 11.9751C65.3388 8.30645 63.9169 5.46367 61.3736 3.29317C58.8273 1.04781 55.3847 0 50.9689 0C46.7036 0 43.1101 0.972949 40.0415 2.91885C37.9158 4.29603 36.105 6.10666 34.7276 8.23219C34.6164 6.99134 34.2331 5.79026 33.6049 4.71442C32.8049 3.34008 31.6035 2.24347 30.162 1.57187C28.6653 0.898084 26.4199 0.524056 23.4262 0.524056H7.5584L0 35.3265H10.8525L13.5467 22.4533H18.3369L18.7112 15.5678H15.0425L16.8387 7.33559H21.0311C23.3514 7.33559 24.474 8.38341 24.474 10.479C24.474 11.8263 23.8754 13.0239 22.8276 14.0717C21.7798 15.0446 20.4116 15.4022 18.7115 15.5687L18.3369 22.4533C21.8323 22.4094 25.2224 22.0041 27.318 21.106C28.6512 20.5662 29.8702 19.7789 30.9107 18.7858C30.8358 19.609 30.7615 20.5071 30.7615 21.2557C30.7615 25.6701 32.1088 29.2639 34.7285 31.9585C37.4227 34.6527 41.24 36 46.2544 36C51.0443 36 54.9364 34.8025 58.0062 32.3313C60.913 29.9797 63.0286 26.7932 64.0679 23.2016L54.0386 21.6298C53.2154 23.8003 52.1676 25.4476 51.0449 26.4196C49.9058 27.4693 48.4021 28.0332 46.8537 27.9915C45.0575 27.9915 43.7102 27.3929 42.8121 26.2702C41.8392 25.0727 41.39 23.6505 41.39 21.9292C41.4062 19.5144 41.8891 17.1255 42.8121 14.894C43.7102 12.4989 44.9078 10.7027 46.4048 9.58006C47.7042 8.48378 49.3452 7.87505 51.0452 7.85875C52.2726 7.85663 53.4627 8.27981 54.4132 9.0563C55.4611 9.87952 55.9103 11.1519 55.9103 12.8741V13.0987L55.8336 13.0978Z" fill="white"/><path opacity="0.8" fill-rule="evenodd" clip-rule="evenodd" d="M89.8129 0.224609H81.4316L59.2017 21.1809L59.1268 21.7049L65.264 22.6779L67.4345 21.7049L79.1108 10.7027L79.2599 10.7776L76.8648 21.7049H67.4345L65.264 22.6779C64.7519 24.326 64.0485 25.9084 63.1684 27.3929L62.1205 29.1894H75.2184L73.7962 35.7009H82.1039L83.5251 29.1894H87.9395L89.5859 21.7049H85.0227L89.8129 0.224609Z" fill="white"/></svg>
            <div class="hamb-nav fixed" @click="showNavMobileExpanded = !showNavMobileExpanded">
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 6H21M11 12H21M6 18H21" stroke="#272727" stroke-width="2" stroke-linecap="round"/></svg>
            </div>
            <NavMobile v-show="showNavMobileExpanded" @close="showNavMobileExpanded = false" />
        </nav>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { Link } from '@inertiajs/inertia-vue3';
import ContactButton from '@/Components/Buttons/ContactButton.vue';
import NavMobile from '@/Components/NavMobile.vue';
import PortfolioDropdown from '@/Components/PortfolioDropdown.vue';

defineProps({
    navColor: {
        type: String,
        required: false,
        default: 'rgba(39, 39, 39, 0.5)'
    },
})

const showNavMobileExpanded = ref(false);
/*
import ContactButton from './buttons/ContactButton.vue';
import NavMobile from './NavMobile.vue';
import PortfolioDropdown from './PortfolioDropdown.vue';

export default {
  components:{
    ContactButton,
    NavMobile,
    PortfolioDropdown
  },
  props:{
    navColor:{
      type:String,
      required:false,
      default:'rgba(39, 39, 39, 0.5)'
    }
  },
  data() {
    return {
      showMenu: false,
      showNavMobileExpanded:false
    }
  },
  computed:{
    currentRoute(){
      return this.$nuxt.$route.path;
    },
    isCurrentRouteHome(){
      return this.currentRoute === '/';
    },
    isCurrentRouteWhoWeAre(){
      return this.currentRoute === '/quem-somos';
    },
  },
  methods: {
    toggleNavbar(){
      this.showMenu = !this.showMenu;
    }
  },
}
*/
</script>

<style lang="postcss" scoped>
.hamb-nav {
  right: 5%;
  z-index: 99;
  @apply fixed;
}

.pc-green-nav{
  color: #78E270 !important;
  border-color: #78E270;
  padding-bottom:1rem;

  @apply border-b-2;
}

.navbar-pc4-desktop {
  @apply py-3 w-full hidden lg:flex flex-wrap items-center justify-between pl-10 pr-10;
}
.nav-contact-items{
  @apply flex items-center;
  & :not(:first-child) {
    @apply pl-4;
  }
}
.nav-about-items > * {
  max-height: 24px !important;

  @apply mr-3 px-2 text-white;
  &:focus {
    @apply pc-green-nav;
  }
}

</style>
